import { MonetaryAmount } from '~/shared/types';

export const MIN_AMOUNT = 0.3;
export const MAX_AMOUNT = 950;
export const MIN_CHARACTERS = 1;
export const MAX_CHARACTERS = 20;

export const POLLING_INTERVAL = 3000;

export const DEFAULT_CURRENCY = 'usd';

export const DEFAULT_VALUES = {
  amount: 50 as MonetaryAmount,
  login: '',
  offer: false,
};
